import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { messages } from '../../messages';
import style from '../../style.module.less';

const ArchiveDownloadColumn = ({ archiveId }) => (
  <div className={style['item-cell']}>
    <Button href={`/api/account/downloadMonthlyArchive/${archiveId}`} target='_blank' theme='link'>
      <FormattedMessage {...messages.archiveDownload} />
    </Button>
  </div>
);

ArchiveDownloadColumn.propTypes = {
  archiveId: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: () => <FormattedMessage {...messages.archiveDownload} />,
  id: 'archiveDownload',
  render: ArchiveDownloadColumn,
};
